import { render } from "./EducationLangManager.vue?vue&type=template&id=8916a62c"
import script from "./EducationLangManager.vue?vue&type=script&lang=js"
export * from "./EducationLangManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__